import axios from 'axios';
import { Injectable } from '@angular/core';
import { environment as env } from '../environments/environment';
@Injectable({ providedIn: 'root' })
export class UploadService {
  private url = `${env.apiUrl}upload`;
  constructor() { }
  public async upload(file?: File, folder?: string, config?: any) {
    try {
      const query = `?contentType=${file?.type}&filename=${file?.name}&folder=${folder}`;
      const uploadUrl = `${this.url}${!!file && !!folder ? query : ''}`;
      const data = await axios.get(uploadUrl, { withCredentials: true, headers: {
        'X-API-Key':'C4G_X9mK7pL2nQ5vB8rT4wY1aZ6cF3jH0sD_2025_DEV_ACCESS'
      } });



      await axios.put(data.data.url, file, config);
      return data.data.url.split("?")[0];
    } catch (error) {
      throw error;
    }
  }
}
